import { setCurrentWorkbook } from '../actions';
import { resetValue } from '../../entity/actions';
import { saveLastProductUsed } from 'util/local-storage-util';
import store from 'state/store';

export * from './character-selection';

// TODO: Handle this differently?
export const selectWorkbook = workbook => {
  return async dispatch => {
    dispatch(resetValue('assignments'));
    dispatch(resetValue('assignmentsById'));
    dispatch(resetValue('classrooms'));
    dispatch(resetValue('classroomsById'));
    dispatch(setCurrentWorkbook(workbook));

    const { user } = store.getState();
    saveLastProductUsed(user.me.id, workbook, user.settings?.locale ?? 'en-US');
  };
};
